import { light_theme_colors } from './shared';
import { ZdsTheme } from './types';

export const lightTheme: ZdsTheme = {
  name: 'light',
  colors: light_theme_colors,
};
